import { render, staticRenderFns } from "./MultipleFormWrapper.vue?vue&type=template&id=0bf8411a&"
import script from "./MultipleFormWrapper.vue?vue&type=script&lang=js&"
export * from "./MultipleFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports